module.exports = __webpack_public_path__ + "img/passport-1.fe51aa8b.png";